import React from 'react'
import { Row, Col, Avatar } from 'antd';
import {
  UserOutlined,
  GithubOutlined,
  QqOutlined,
  WeiboOutlined,
  ZhihuOutlined,
  WechatOutlined,
  TwitterOutlined,
  ArrowRightOutlined
} from '@ant-design/icons';

const SidePersonComponent = function () {
  return (
    <Row gutter={18}>
      <Col span={24}>
        <div className="shuji-container">
          <div className="shuji-header">
            <div className="shuji-title">
              推荐书籍
            </div>
            <div className="shuji-more">
              更多 <ArrowRightOutlined />
            </div>
          </div>
          <div className="shuji-wrapper">
            {
              [
                { url: 'images/s33849778.jpeg', name: '美丽黑暗', intro: '屏住呼吸的你，是否也在想“从天而降的粘液，究竟是什么”？' },
                { url: 'images/s33660509.jpeg', name: '失落的卫星', intro: '我们生而自由，却往往身不由己。在隔绝和封闭的时代，聆听游荡世界的回声。' },
                { url: 'images/s33576192.jpeg', name: '无形之手', intro: '无人知道该做什么，去哪里，为什么。 我想着你，我们的亲密，秋天 来临时你头发的香味。' }
              ].map(item => {
                return (
                  <div className="shuji-item">
                    <div className="item-fm" style={{ backgroundImage: `url(${item.url})` }}></div>
                    <div className="item-right">
                      <div className="item-name">{item.name}</div>
                      <div className="item-intro">{item.intro}</div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </Col>
    </Row>
  )
}
export default SidePersonComponent